import React from 'react';
import { Box, Typography } from '@mui/material';
import { hoverLift } from './landingStyles';

const steps = [
  {
    title: 'Enter the deal',
    body: 'Purchase, rehab, financing and exit assumptions.',
  },
  {
    title: 'Skout the numbers',
    body: 'Profit, cash required, project return and break-even.',
  },
  {
    title: 'Validate the ARV',
    body: 'Add comps manually, import them, or find recent sold properties automatically.',
  },
  {
    title: 'Stress test the deal',
    body: 'See what happens when sale price, rehab or holding time moves against you.',
  },
  {
    title: 'Know what to verify',
    body: "AI Deal Review explains strengths, concerns and next steps using DealSkout's saved evidence.",
  },
];

const HowItWorks: React.FC = () => {
  return (
    <Box component="section" id="how-it-works" aria-labelledby="how-it-works-title" sx={{ scrollMarginTop: 88 }}>
      <Typography id="how-it-works-title" variant="h4" component="h2" sx={{ fontWeight: 800, mb: 1 }}>
        How DealSkout works
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: 640 }}>
        Five steps from a property you are considering to a deal you understand.
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(5, 1fr)' },
          gap: 2,
        }}
      >
        {steps.map((step, index) => (
          <Box
            key={step.title}
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: 'background.paper',
              border: '1px solid',
              borderColor: 'divider',
              ...hoverLift,
            }}
          >
            <Box
              aria-hidden
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                bgcolor: 'brand.yellow',
                color: 'brand.navy',
                display: 'grid',
                placeItems: 'center',
                fontWeight: 800,
                mb: 1.5,
              }}
            >
              {index + 1}
            </Box>
            <Typography component="h3" variant="subtitle1" sx={{ fontWeight: 800, mb: 0.5 }}>
              {step.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {step.body}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default HowItWorks;
